/* Theme behaviour — small, dependency-free, progressive. */
(function () {
  'use strict';

  var MONEY_FORMAT = window.themeMoneyFormat || '{{amount}} TL';

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    return MONEY_FORMAT.replace(/\{\{\s*amount\s*\}\}/, value);
  }

  function on(event, selector, handler) {
    document.addEventListener(event, function (e) {
      var match = e.target.closest(selector);
      if (match) handler(e, match);
    });
  }

  /* ---- Mobile nav drawer ------------------------------------------------ */
  function initDrawer() {
    var drawer = document.querySelector('[data-drawer]');
    var scrim = document.querySelector('[data-drawer-scrim]');
    if (!drawer) return;

    function setOpen(open) {
      drawer.setAttribute('data-open', open);
      if (scrim) scrim.setAttribute('data-open', open);
      document.documentElement.style.overflow = open ? 'hidden' : '';
      var opener = document.querySelector('[data-drawer-open]');
      if (opener) opener.setAttribute('aria-expanded', open);
      if (open) {
        var close = drawer.querySelector('[data-drawer-close]');
        if (close) close.focus();
      } else if (opener) {
        opener.focus();
      }
    }

    on('click', '[data-drawer-open]', function (e) { e.preventDefault(); setOpen(true); });
    on('click', '[data-drawer-close], [data-drawer-scrim]', function () { setOpen(false); });

    on('click', '[data-drawer-toggle]', function (e, toggle) {
      var sub = toggle.nextElementSibling;
      if (!sub) return;
      var open = sub.getAttribute('data-open') === 'true';
      sub.setAttribute('data-open', !open);
      toggle.setAttribute('aria-expanded', !open);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('data-open') === 'true') setOpen(false);
    });
  }

  /* ---- Product gallery (mobile swipe slider) ----------------------------- */
  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      if (gallery.dataset.galleryBound === 'true') return;
      gallery.dataset.galleryBound = 'true';

      var wrap = gallery.closest('.gallery-wrap');
      var dotsWrap = wrap ? wrap.querySelector('[data-gallery-dots]') : null;
      var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.querySelectorAll('[data-gallery-dot]')) : [];
      if (!dots.length) return;

      var ticking = false;
      function updateActive() {
        ticking = false;
        var index = Math.round(gallery.scrollLeft / gallery.clientWidth);
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }

      gallery.addEventListener('scroll', function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(updateActive);
        }
      }, { passive: true });

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          var item = gallery.children[i];
          if (item) gallery.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
        });
      });
    });
  }

  /* ---- Mega menu tabs ---------------------------------------------------- */
  function initMegaMenu() {
    document.querySelectorAll('.megaflyout').forEach(function (flyout) {
      flyout.addEventListener('mouseover', function (e) {
        var tab = e.target.closest('[data-mega-tab]');
        if (!tab) return;
        activate(flyout, tab.dataset.megaTab);
      });

      flyout.addEventListener('click', function (e) {
        var tab = e.target.closest('[data-mega-tab]');
        if (!tab) return;
        activate(flyout, tab.dataset.megaTab);
      });

      flyout.addEventListener('focusin', function (e) {
        var tab = e.target.closest('[data-mega-tab]');
        if (!tab) return;
        activate(flyout, tab.dataset.megaTab);
      });
    });

    function activate(flyout, index) {
      flyout.querySelectorAll('[data-mega-tab]').forEach(function (t) {
        t.setAttribute('aria-selected', t.dataset.megaTab === index ? 'true' : 'false');
      });
      flyout.querySelectorAll('[data-mega-panel]').forEach(function (p) {
        if (p.dataset.megaPanel === index) p.removeAttribute('hidden');
        else p.setAttribute('hidden', '');
      });
    }
  }

  /* ---- Search panel ----------------------------------------------------- */
  function initSearch() {
    var panel = document.querySelector('[data-searchbar]');
    if (!panel) return;

    on('click', '[data-search-toggle]', function (e, btn) {
      e.preventDefault();
      var open = panel.getAttribute('data-open') !== 'true';
      panel.setAttribute('data-open', open);
      btn.setAttribute('aria-expanded', open);
      if (open) {
        var input = panel.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') panel.setAttribute('data-open', 'false');
    });
  }

  /* ---- Accordions ------------------------------------------------------- */
  function initAccordions() {
    on('click', '[data-acc-head]', function (e, head) {
      var panel = head.nextElementSibling;
      if (!panel) return;
      var open = panel.getAttribute('data-open') === 'true';
      panel.setAttribute('data-open', !open);
      head.setAttribute('aria-expanded', !open);
      var sign = head.querySelector('[data-acc-sign]');
      if (sign) sign.textContent = open ? '+' : '\u2212';
    });
  }

  /* ---- Cart (AJAX) ------------------------------------------------------ */
  var Cart = {
    openDrawer: function () {
      var drawer = document.querySelector('[data-cart-drawer]');
      var scrim = document.querySelector('[data-cart-scrim]');
      if (!drawer) return;
      drawer.setAttribute('data-open', 'true');
      drawer.setAttribute('aria-hidden', 'false');
      if (scrim) scrim.setAttribute('data-open', 'true');
      document.documentElement.style.overflow = 'hidden';
      var close = drawer.querySelector('[data-cart-close]');
      if (close) close.focus();
    },

    closeDrawer: function () {
      var drawer = document.querySelector('[data-cart-drawer]');
      var scrim = document.querySelector('[data-cart-scrim]');
      if (!drawer) return;
      drawer.setAttribute('data-open', 'false');
      drawer.setAttribute('aria-hidden', 'true');
      if (scrim) scrim.setAttribute('data-open', 'false');
      document.documentElement.style.overflow = '';
    },

    refresh: function () {
      return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + '?sections=cart-drawer' : '/?sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data['cart-drawer'];
          if (!html) return;
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var fresh = parsed.querySelector('[data-cart-drawer]');
          var current = document.querySelector('[data-cart-drawer]');
          if (fresh && current) {
            var wasOpen = current.getAttribute('data-open');
            current.innerHTML = fresh.innerHTML;
            current.setAttribute('data-open', wasOpen);
          }
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          if (!cart) return;
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
        });
    },

    add: function (variantId, quantity) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (err) { throw err; });
          return r.json();
        })
        .then(function () { return Cart.refresh(); })
        .then(function () { Cart.openDrawer(); });
    },

    change: function (key, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function () { return Cart.refresh(); });
    }
  };

  function initCart() {
    on('click', '[data-cart-open]', function (e) { e.preventDefault(); Cart.refresh().then(Cart.openDrawer); });
    on('click', '[data-cart-close], [data-cart-scrim]', function () { Cart.closeDrawer(); });

    document.addEventListener('keydown', function (e) {
      var drawer = document.querySelector('[data-cart-drawer]');
      if (e.key === 'Escape' && drawer && drawer.getAttribute('data-open') === 'true') Cart.closeDrawer();
    });

    on('click', '[data-quick-add]', function (e, btn) {
      e.preventDefault();
      btn.disabled = true;
      Cart.add(parseInt(btn.dataset.quickAdd, 10), 1)
        .catch(function () { window.location.href = btn.closest('.pcard').querySelector('.pcard__media').href; })
        .finally(function () { btn.disabled = false; });
    });

    on('click', '[data-cart-change]', function (e, btn) {
      var input = btn.parentElement.querySelector('input');
      var next = parseInt(input.value, 10) + parseInt(btn.dataset.delta, 10);
      Cart.change(btn.dataset.cartChange, Math.max(0, next));
    });

    document.addEventListener('change', function (e) {
      if (e.target.matches('[data-cart-set]')) {
        Cart.change(e.target.dataset.cartSet, Math.max(0, parseInt(e.target.value, 10) || 0));
      }
    });

    // Product form -> AJAX add
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-product-form]');
      if (!form) return;
      var idInput = form.querySelector('[data-variant-id]');
      if (!idInput) return;
      e.preventDefault();
      var btn = form.querySelector('[data-submit]');
      var qtyInput = form.querySelector('[data-product-qty]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      if (btn) btn.disabled = true;
      Cart.add(parseInt(idInput.value, 10), qty)
        .catch(function () { form.submit(); })
        .finally(function () { if (btn) btn.disabled = false; });
    });
  }

  /* ---- Variant selection ------------------------------------------------ */
  function initVariants() {
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      var data = form.querySelector('[data-variants]');
      if (!data) return;

      var variants;
      try { variants = JSON.parse(data.textContent); } catch (err) { return; }

      var idInput = form.querySelector('[data-variant-id]');
      var priceEl = form.querySelector('[data-price]');
      var submit = form.querySelector('[data-submit]');

      function selected() {
        return Array.from(form.querySelectorAll('[data-option-index]'))
          .filter(function (i) { return i.checked; })
          .sort(function (a, b) { return a.dataset.optionIndex - b.dataset.optionIndex; })
          .map(function (i) { return i.value; });
      }

      function update() {
        var picked = selected();
        var match = variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === picked[i]; });
        });

        form.querySelectorAll('[data-option-index]').forEach(function (input) {
          if (!input.checked) return;
          var readout = form.querySelector('[data-option-readout="' + input.dataset.optionIndex + '"]');
          if (readout) readout.textContent = input.value;
        });

        if (!match) {
          if (submit) { submit.disabled = true; submit.textContent = submit.dataset.unavailable; }
          return;
        }

        if (idInput) idInput.value = match.id;
        if (priceEl && match.price_html) priceEl.innerHTML = match.price_html;

        if (submit) {
          submit.disabled = !match.available;
          submit.textContent = match.available ? submit.dataset.add : submit.dataset.soldout;
        }

        if (window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      form.addEventListener('change', function (e) {
        if (e.target.matches('[data-option-index]')) update();
      });

      update();
    });
  }

  /* ---- Quantity steppers ------------------------------------------------ */
  function initQty() {
    on('click', '[data-qty]', function (e, btn) {
      var input = btn.parentElement.querySelector('input');
      if (!input) return;
      var next = parseInt(input.value, 10) + parseInt(btn.dataset.qty, 10);
      input.value = Math.max(parseInt(input.min || 1, 10), next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---- Sorting and filters ---------------------------------------------- */
  function initCollection() {
    var sort = document.querySelector('[data-sort]');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    var panel = document.querySelector('[data-filters]');
    if (panel) {
      on('click', '[data-filters-open]', function () { panel.setAttribute('data-open', 'true'); document.documentElement.style.overflow = 'hidden'; });
      on('click', '[data-filters-close]', function () { panel.setAttribute('data-open', 'false'); document.documentElement.style.overflow = ''; });
    }

    var form = document.querySelector('[data-filter-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var params = new URLSearchParams();
        new FormData(form).forEach(function (value, key) {
          if (value === '' || value == null) return;
          if (key.indexOf('price') > -1) value = value; // price params are in major units
          params.append(key, value);
        });
        window.location.href = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
      });
    }
  }

  /* ---- Wishlist (local to this browser) --------------------------------- */
  var Wishlist = {
    key: 'theme:wishlist',
    all: function () {
      try { return JSON.parse(localStorage.getItem(Wishlist.key)) || []; }
      catch (e) { return []; }
    },
    has: function (handle) { return Wishlist.all().indexOf(handle) > -1; },
    toggle: function (handle) {
      var list = Wishlist.all();
      var i = list.indexOf(handle);
      if (i > -1) list.splice(i, 1); else list.unshift(handle);
      try { localStorage.setItem(Wishlist.key, JSON.stringify(list.slice(0, 100))); } catch (e) {}
      return Wishlist.has(handle);
    }
  };

  function paintWishlist() {
    document.querySelectorAll('[data-wish]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', Wishlist.has(btn.dataset.wish));
    });
  }

  function initWishlist() {
    paintWishlist();

    on('click', '[data-wish]', function (e, btn) {
      e.preventDefault();
      var active = Wishlist.toggle(btn.dataset.wish);
      btn.setAttribute('aria-pressed', active);
    });

    var list = document.querySelector('[data-wishlist-list]');
    if (!list) return;

    var handles = Wishlist.all();
    var empty = document.querySelector('[data-wishlist-empty]');
    if (!handles.length) return;

    Promise.all(handles.map(function (handle) {
      return fetch('/products/' + handle + '?view=card')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (chunks) {
      var html = chunks.filter(Boolean).map(function (c) { return '<li>' + c + '</li>'; }).join('');
      if (!html) return;
      list.innerHTML = html;
      list.hidden = false;
      if (empty) empty.hidden = true;
      paintWishlist();
    });
  }

  /* ---- Recently viewed --------------------------------------------------- */
  function initRecentlyViewed() {
    var KEY = 'theme:recent';
    var viewed = document.querySelector('[data-track-view]');

    function read() {
      try { return JSON.parse(localStorage.getItem(KEY)) || []; }
      catch (e) { return []; }
    }

    if (viewed) {
      var handle = viewed.dataset.trackView;
      var list = read().filter(function (h) { return h !== handle; });
      list.unshift(handle);
      try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 12))); } catch (e) {}
    }

    var wrap = document.querySelector('[data-recently-viewed]');
    if (!wrap) return;

    var current = viewed ? viewed.dataset.trackView : null;
    var handles = read().filter(function (h) { return h !== current; }).slice(0, 8);
    if (!handles.length) return;

    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '?view=card')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (chunks) {
      var html = chunks.filter(Boolean).map(function (c) { return '<li>' + c + '</li>'; }).join('');
      if (!html) return;
      wrap.querySelector('[data-recently-list]').innerHTML = html;
      wrap.hidden = false;
      paintWishlist();
    });
  }

  /* ---- Order tracking ---------------------------------------------------- */
  function initTracking() {
    on('click', '[data-track-go]', function () {
      var carrier = document.querySelector('[data-track-carrier]');
      var number = document.querySelector('[data-track-number]');
      var error = document.querySelector('[data-track-error]');
      if (!carrier || !number) return;

      var code = number.value.trim();
      if (!code) {
        if (error) error.hidden = false;
        number.focus();
        return;
      }
      if (error) error.hidden = true;

      var url = carrier.value.replace('{code}', encodeURIComponent(code));
      window.open(url, '_blank', 'noopener');
    });
  }

  /* ---- Country / province linking (addresses) ---------------------------- */
  function initAddressFields() {
    document.querySelectorAll('[data-country]').forEach(function (country) {
      var province = country.closest('.field-grid').querySelector('[data-province]');
      if (!province) return;

      function sync() {
        var option = country.options[country.selectedIndex];
        var values = option ? option.getAttribute('data-provinces') : null;
        var list = [];
        try { list = JSON.parse(values) || []; } catch (e) {}

        province.innerHTML = '';
        if (!list.length) {
          province.closest('label').style.display = 'none';
          return;
        }
        province.closest('label').style.display = '';
        list.forEach(function (pair) {
          var opt = document.createElement('option');
          opt.value = pair[0];
          opt.textContent = pair[1];
          province.appendChild(opt);
        });
        if (province.dataset.default) province.value = province.dataset.default;
      }

      if (country.dataset.default) country.value = country.dataset.default;
      country.addEventListener('change', sync);
      sync();
    });
  }

  function boot() {
    initDrawer();
    initGallery();
    initMegaMenu();
    initSearch();
    initAccordions();
    initCart();
    initVariants();
    initQty();
    initCollection();
    initWishlist();
    initRecentlyViewed();
    initTracking();
    initAddressFields();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
